export enum QUERY_CACHE_IDS_MAP {
  ORDER = 'ORDER',
  NOTE = 'NOTES',
  ORDER_LIST = 'ORDER_LIST',
  ADDRESS = 'ADDRESS',
  REPORTS = 'REPORTS',
  REPORT = 'REPORT',
  ATTACHMENTS = 'ATTACHMENTS',
  CONTACTS = 'CONTACTS',
  BRANCH = 'BRANCH',
}
